export const opacityVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 2,
    },
  },
};

export const opacityVariants2 = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 3,
    },
  },
};

export const opacityVariants3 = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 4,
    },
  },
};
